export default __webpack_public_path__ + "static/media/(64).1745c420.jpg";